import { NgModule } from '@angular/core';
import { BorderBeamDirective } from './border-beam.directive';

@NgModule({
    declarations: [
        BorderBeamDirective
    ],
    imports: [],
    exports: [
        BorderBeamDirective
    ]
})
export class NcBorderBeamModule { }